import Box from 'components/shared/Box'
import { shouldForwardProp } from 'helpers'
import styled, { css } from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'
import { applyThickLeftBorder } from 'styles/mixins'

type StyledSimpleRadioTileGroupItemProps = {
    isChecked?: boolean
    isDisabled?: boolean
    isError?: boolean
    isRadioMarkVisible?: boolean
    isBigVariant?: boolean
}

export const StyledSimpleRadioTileGroupItem = styled(Box).withConfig({
    shouldForwardProp: (prop) =>
        shouldForwardProp<StyledSimpleRadioTileGroupItemProps>(
            [
                'isChecked',
                'isDisabled',
                'isError',
                'isRadioMarkVisible',
                'isBigVariant',
            ],
            prop
        ),
})<StyledSimpleRadioTileGroupItemProps>`
    max-width: 100%;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.grayscale_200};
    padding: ${({ isRadioMarkVisible }) =>
        isRadioMarkVisible ? '14px' : '8px 6px'}; // considered 2px for border
    flex-direction: row;
    gap: 16px;
    align-items: center;
    border: 2px solid ${({ theme }) => theme.colors.grayscale_200};
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
    position: relative;
    overflow: hidden;

    @media ${respondAbove.xl} {
        // considered 2px for border
        padding: ${({ isRadioMarkVisible, isBigVariant }) => {
            const basePadding = isBigVariant ? '16px 24px' : '22px'
            return isRadioMarkVisible ? basePadding : '8px 6px'
        }};

        ${({ isBigVariant, isChecked }) =>
            isChecked &&
            isBigVariant &&
            css`
                ${applyThickLeftBorder()}
            `}
    }

    ${({ isChecked }) =>
        isChecked &&
        css`
            background-color: ${({ theme }) => theme.colors.grayscale_0};
            border: 2px solid ${({ theme }) => theme.colors.primary_500};
        `}
    ${({ isDisabled }) =>
        isDisabled &&
        css`
            opacity: 0.4;
        `}
`

export const RadioButtonWrapper = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        shouldForwardProp<{ isVisible?: boolean }>(['isVisible'], prop),
})<{ isVisible?: boolean }>`
    pointer-events: none;
    display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
`
